__turbopack_context__.v({
  "allNewsBtn": "rj4iyG_allNewsBtn",
  "contentStyles": "rj4iyG_contentStyles",
  "newsBottomController": "rj4iyG_newsBottomController",
  "rowsContainer": "rj4iyG_rowsContainer",
  "showAllNewsBtn": "rj4iyG_showAllNewsBtn",
  "sliderControllerBtn": "rj4iyG_sliderControllerBtn",
  "sliderControllerBtnDiactive": "rj4iyG_sliderControllerBtnDiactive",
  "titleH3Styles": "rj4iyG_titleH3Styles",
});
